import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from 'angularfire2/firestore';
import { inventory } from './inventory.model';
import { Observable } from 'rxjs'

@Injectable()
export class InventoryService {
    public pushID: any;
    vehMaintDocCol: AngularFirestoreCollection<inventory>;
    vehMaintDoc: AngularFirestoreDocument<inventory>;
    vehStatusCol: AngularFirestoreCollection<inventory>;
    vehStatusDoc: AngularFirestoreDocument<inventory>;
    vehiclesMaint: Observable<inventory[]>

    maintItems: Observable<inventory[]>;

    maintItemsStatus: Observable<inventory[]>;

    constructor(public afs: AngularFirestore) {
        this.vehMaintDocCol = this.afs.collection('Maintenance');
        this.vehStatusCol = this.afs.collection('VeicleStatus')

        // this.vehiclesMaint = this.vehMaintDocCol.snapshotChanges().map(changes => {
        //     return changes.map(a => {
        //         const data = a.payload.doc.data() as MaintVehicle;
        //         data.id = a.payload.doc.id;
        //         return data;
        //     })UccUsersService
        // });data
        this.maintItems = this.afs.collection('Maintenance').valueChanges();
    }
    addInventoryHistory(data) {
        var doc_id = this.afs.createId();
        this.vehMaintDoc = this.afs.collection("store_history_data")
                            .doc(data.partID)
                            .collection(data.date)
                            .doc(doc_id);
                            this.vehMaintDoc.set(data.data)
    }

    getInventoryHistory(obj) {
        this.maintItems = this.afs.collection('Maintenance', ref => ref
            // .where('statusDate', '==', obj.statusDate)
            .where('Status', '==', obj.Status)
            .where('stage', '==', obj.stage)
            .where('tab_position', '==', obj.tab_position)
            .where('request_status', '==', obj.request_status)
            .where('prjid', '==', obj.prjid).where('vehId', '==', obj.vehId))
            .valueChanges();
        // console.log("para", obj)
        return this.maintItems
    };
}


// WEBPACK FOOTER //
// ./src/app/maintenance/part/partMaster/inventory.service.ts